import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface IVendor {
	vendorId: number;
	name: string;
	teamCode: string | null;
	crawlerId: number | null;
}

const initialState: Array<IVendor> = [];

const vendorsPath = "/passwordManager/Vendors";

const buildExternalUrl = () => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Vendors`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getVendors, slice: vendorsSlice } = getThunkAndSlice<Record<string, never>, Array<IVendor>>({
	initialState,
	path: vendorsPath,
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
